/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DashboardAliases {
  ACTION_APPOINTMENTS = 'action-appointments',
  ACTION_EXAMS = 'action-exams',
  ACTION_NEW_APPOITMENT = 'action-new-appoitment',
  ACTION_TASKS = 'action-tasks',
  APPOINTMENT_DASHBOARD_CARD = 'appointment-dashboard-card',
  APPOINTMENTS_FETCH = 'appointments-fetch',
  APPOINTMENTS_TRAIL = 'appointments-trail',
  BOTTOM_LAYOUT = 'bottom-layout',
  CARD_EXAMS_LIST_ITEM = 'card-exams-list-item',
  CARD_WAITING_LIST_0 = 'card-waiting-list-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_2 = 'contextual-bar-2',
  DECK_EXAMS = 'deck-exams',
  DECK_TASK_LIST = 'deck-task-list',
  FETCH_EXAMS = 'fetch-exams',
  FETCH_TASK_LIST = 'fetch-task-list',
  FETCH_WAITING_LIST = 'fetch-waiting-list',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  LAYOUT_DASHBOARD = 'layout-dashboard',
  LAYOUT_OUTER = 'layout-outer',
  MY_EXAMS_CONTEXTUAL_BAR = 'my-exams-contextual-bar',
  MY_PROPERTIES_PANEL = 'my-properties-panel',
  PA_WAITING_CONTEXTUAL_BAR = 'pa-waiting-contextual-bar',
  PA_WAITING_PANEL = 'pa-waiting-panel',
  PANEL_APPOINTMENT = 'panel-appointment',
  PANEL_BOTTOM_LAYOUT = 'panel-bottom-layout',
  PANEL_CONTENT = 'panel-content',
  PANEL_EXAMS_LIST = 'panel-exams-list',
  PANEL_TASK_LIST = 'panel-task-list',
  PANEL_TASKS = 'panel-tasks',
  PANEL_UPPER_LAYOUT = 'panel-upper-layout',
  PANEL_WAITING_LIST = 'panel-waiting-list',
  ROOT_PANEL = 'root-panel',
  SCHEDULE_TASKS_PROGRESS_CARD = 'schedule-tasks-progress-card',
  TRAIL_WAITING_LIST_API = 'trail-waiting-list-api',
  UPPER_LAYOUT = 'upper-layout',
}
export { DashboardAliases };
